import React from 'react'
import get from 'lodash/get'


class Hero extends React.Component {
    render(){
        let heroTitle 
        let heroSubtitle
        if (this.props.title){
            heroTitle = this.props.title
        }
        if (this.props.subtitle){
            heroSubtitle = this.props.subtitle
        }
        return (
            <section className="hero is-light is-bold">
            <div className="hero-body">
                <div className="container">
                    <h1 className="title">
                        {heroTitle}
                    </h1>
                    <h2 className="subtitle">
                        {heroSubtitle}
                    </h2>
                </div>
            </div>
            </section>
        )
    }


}

export default Hero


// WEBPACK FOOTER //
// ./src/components/Hero.js